import {h, Component} from 'preact';
import {connect} from 'react-redux';

import reduce from '../reducers';
import * as actions from '../actions';

import Zoom from './Zoom';
import History from './History';
import PageTools from './PageTools';
import PageNavTools from "./PageNavTools";

export default @connect(reduce, actions)
class RightMenu extends Component {
   constructor() {
    super();
  }

  render(props, state) {
    return (
      <div className={'right-menu'}>
        <PageTools />
        <Zoom onFullScreen={props.onFullScreen}/>
        <History/>
        <PageNavTools />
      </div>
    )
  }
}
